module.exports = __webpack_public_path__ + "img/chinesecompany141.4fc8e68d.png";